import _assign from "object-assign";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { fade } from './internal/utils/fade';
var offsets = {
  touch: 4,
  low: 4,
  medium: 2,
  high: 2
};
// TODO: I suspect there's a very basic default text characteristic we can refactor out of this to be reused here and elsewhere
var densityToTypeSizePaletteIndex = {
  touch: '70',
  low: '60',
  medium: '50',
  high: '40'
};
export var buttonStyle = function buttonStyle(_ref) {
  var toolkitTheme = _ref.toolkit;
  var _toolkitTheme$action = toolkitTheme.action,
      getAction = _toolkitTheme$action.getAction,
      actionVariants = _toolkitTheme$action.actionVariants,
      getDisabled = toolkitTheme.disabled.getDisabled,
      getFocusable = toolkitTheme.focusable.getFocusable,
      spacing = toolkitTheme.spacing,
      getSize = toolkitTheme.size.getSize,
      typography = toolkitTheme.typography;

  var _getDisabled = getDisabled(),
      disabledOpacity = _getDisabled.opacity;

  var _getDisabled2 = getDisabled('graphical'),
      graphicalDisabledOpacity = _getDisabled2.opacity;

  var createDensityStyle = function createDensityStyle(density) {
    var fontSize = typography.size[densityToTypeSizePaletteIndex[density]];
    var spacingMixin = spacing[density].spacing; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

    var _ref2 = getSize({
      density: density
    }),
        height = _ref2.height;

    var padding = spacingMixin(1);
    return {
      fontSize: fontSize,
      height: height,
      padding: [[0, padding]],
      '&$inputButton': {
        height: height - offsets[density] * 2,
        margin: offsets[density],
        padding: [[0, padding - offsets[density]]]
      }
    };
  };

  var createVariantStyle = function createVariantStyle(variant) {
    var _getAction = getAction({
      variant: variant
    }),
        _getAction$default = _getAction["default"],
        defaultIcon = _getAction$default.icon,
        defaultStyles = _objectWithoutProperties(_getAction$default, ["icon"]),
        _getAction$active = _getAction.active,
        activeIcon = _getAction$active.icon,
        activeStyles = _objectWithoutProperties(_getAction$active, ["icon"]),
        _getAction$hover = _getAction.hover,
        hoverIcon = _getAction$hover.icon,
        hoverStyles = _objectWithoutProperties(_getAction$hover, ["icon"]);

    var disabledBackgroundColor = fade(defaultStyles.background, graphicalDisabledOpacity);
    return _assign({}, defaultStyles, typography.getFace(variant === 'secondary' ? 'semiBold' : 'bold'), {
      lineHeight: typography.lineHeight,
      letterSpacing: '0.6px',
      textTransform: 'uppercase',
      '&:hover': _assign({}, hoverStyles, {
        '& $icon:not($:active)': {
          color: hoverIcon
        }
      }),
      '&:active, &.active': _assign({}, activeStyles, {
        '& $icon': {
          color: activeIcon
        }
      }),
      '&:visited': {
        color: defaultStyles.color
      },
      '& $icon': {
        color: defaultIcon
      },
      '&$disabled': {
        color: "".concat(fade(defaultStyles.color, disabledOpacity), " !important"),
        background: "".concat(disabledBackgroundColor, " !important"),
        '& $icon': {
          color: "".concat(fade(defaultStyles.color, graphicalDisabledOpacity), " !important")
        }
      }
    });
  };

  return {
    disabled: {
      pointerEvents: 'inherit !important'
    },
    regular: createVariantStyle(actionVariants.regular),
    cta: createVariantStyle(actionVariants.cta),
    secondary: createVariantStyle(actionVariants.secondary),
    touchDensity: createDensityStyle('touch'),
    lowDensity: createDensityStyle('low'),
    mediumDensity: createDensityStyle('medium'),
    highDensity: createDensityStyle('high'),

    /* Styles applied to the root element if used in an input CE */
    inputButton: {},

    /* Styles applied to the root element if keyboard focused */
    focusVisible: getFocusable(),

    /* Styles applied to the root element if `fullWidth={true}` */
    fullWidth: {},

    /* Styles applied to the icon element */
    icon: {
      color: 'inherit',
      letterSpacing: 0
    },

    /* Styles applied to the span element that wraps the children */
    label: {
      position: 'relative',
      alignItems: 'center',
      display: 'flex',
      height: '100%',
      // Fixes IE11 CE. pre makes the button really wide.
      '&:not(.style-scope)': {
        whiteSpace: 'pre'
      }
    },

    /* Styles applied to the root element */
    root: {
      borderRadius: 0,
      appearance: 'none',
      minWidth: 0,
      minHeight: 0,
      display: 'inline-block',
      position: 'relative',
      transition: 'none',
      textAlign: 'center',
      userSelect: 'none',
      '&:not($focusVisible)': {
        outline: '1px solid transparent'
      },
      '&[href]': {
        display: 'inline-flex'
      },
      '&::-moz-focus-inner': {
        padding: 0,
        border: 0
      },
      '&$disabled': {
        cursor: 'not-allowed'
      }
    } // temporary cast as many of our properties are not allowed by mui types

  };
};
//# sourceMappingURL=style.js.map